export default{
    methods:{
        formatar(mascara, e)
        {
            let i     = e.target.value.length
            let saida = mascara.substring(0,1)
            let texto = mascara.substring(i)
            if (texto.substring(0,1) != saida) e.target.value += texto.substring(0,1)
        }
    }
}


// WEBPACK FOOTER //
// ./src/helpers/Mask.js